import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { isoToMysqlDateTime } from "../../inc/helper";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML, convertToRaw} from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';

class AuctionEditModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

			auction: {},
      contract: ''
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
		this.getAuctionInfo();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

	getAuctionInfo() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'auction/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200:
          const blocksFromHTML = convertFromHTML(responseData.auctionInfo.contract);
          const content = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
          this.setState({isLoading: false, auction: responseData.auctionInfo, contract: EditorState.createWithContent(content)})
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/auctions'))
        break;
        default:
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        break;
      }
    }, () =>swal({ dangerMode: true, icon: "error", title: "Bağlantı Hatası", text: "Lütfen internet bağlantınızı kontrol ediniz.", buttons: "Yeniden Dene",}).then(() => this.getMyAppointmentsDetail()));
  }

  saveAuctionOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

  	const startDateIso = new Date(this.state.auction.startDate).toISOString();
    const endDateIso = new Date(this.state.auction.endDate).toISOString();

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({title: this.state.auction.title, description: this.state.auction.description, provider: this.state.auction.provider, contract: draftToHtml(convertToRaw(this.state.contract.getCurrentContent())), startDate: startDateIso, endDate: endDateIso})
    };

    fetch(config.restApi + 'auction/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'İhale bilgileri başarıyla güncellendi.',
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/auctions'));
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  onChange(contract) {
    this.setState({contract: contract})
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.saveBlogOnClick();
    }
  }

  render() {
    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between text-darkblue pr-2">
              <h4 className="text-darkblue">İhale Düzenle</h4>
              <div className="d-flex">
								<button className="btn bg-orange text-white mr-1" onClick={this.saveAuctionOnClick} title="Kaydet"><i className="fa fa-save"></i></button>
								<button className="btn border btn-darkblue text-white" onClick={() => this.props.navigate(-1)} title="Geri"> <i className="fa fa-reply"></i></button>
							</div>
            </div>
            <div className="row">
              <div className="col">
                <div className="ibox">
                  <div className="ibox-content text-darkblue">
                    <div className="row">
                      <div className="col">
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Başlık<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-control-sm form-input mb-1" onChange={event => this.setState(prevState => ({auction: {...prevState.auction, title: event.target.value}}))} onKeyDown={this.handleKeyPress} placeholder="Başlık" type="text" value={this.state.auction.title || ''} />
                        </div>
												<div className="col-md-6">
                          <h5><strong>Sağlayıcı<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({auction: {...prevState.auction, provider: event.target.value}}))} onKeyDown={this.handleKeyPress} placeholder="Sağlayıcı" type="text" value={this.state.auction.provider || ''} />
                        </div>
                      </div>
                      <div className="row">
												<div className="col-12">
                          <h5><strong>Açıklama<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-control-sm form-input mb-1" onChange={event => this.setState(prevState => ({auction: {...prevState.auction, description: event.target.value}}))} onKeyDown={this.handleKeyPress} placeholder="Açıklama" type="text" value={this.state.auction.description || ''} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Başlangıç Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState(prevState => ({auction: {...prevState.auction, startDate: event.target.value}}))} onKeyDown={this.handleKeyPress} type="datetime-local" value={isoToMysqlDateTime(this.state.auction.startDate || '')}/>
                        </div>
                        <div className="col-md-6">
                          <h5><strong>Bitiş Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState(prevState => ({auction: {...prevState.auction, endDate: event.target.value}}))} onKeyDown={this.handleKeyPress} type="datetime-local" value={isoToMysqlDateTime(this.state.auction.endDate || '')}/>
                        </div>
												<div className="col-12">
                          <h5><strong>Sözleşme<strong className="text-danger ml-1">*</strong></strong></h5>
                          <Editor
                            editorClassName="editor-class"
                            editorState={this.state.contract}
                            onEditorStateChange={this.onChange}
                            onKeyDown={this.handleKeyPress}
                            editorStyle={{border: '1px solid #F1F1F1', height: '25vh'}}
                          ></Editor>
                        </div>
                      </div>
                      </div>
                    </div>
                    <div className="text-row text-right mt-2">
                      <button className="btn bg-orange text-white" onClick={this.saveAuctionOnClick}><i className="fa fa-save"></i> Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionEdit(props) {
  return (
    <AuctionEditModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionEditModule>
  );
}
